import React from 'react';

import {
  Col,
  DropdownToggle,
  DropdownMenu,
  UncontrolledDropdown,
  Row,
  DropdownItem
} from 'reactstrap';
import {
  MdDriveEta,
  MdPerson,
  MdContentPaste
} from 'react-icons/lib/md';


const AutoInfracaoResumo = ({ infracao: infracaoJson }) => {
  const { condutor = {}, veiculo, ...infracao } = infracaoJson;
  const { proprietario = {}, enderecoEmplacamento = {} } = veiculo;
  const dataHora = infracao.dataHora ? new Date(infracao.dataHora).toLocaleString() : "";
  return (
    <div>
      <Row className="bg-dark text-white ">
        <Col sm="10">
          <small>Placa: {veiculo.placa}<br />
            Infração: {infracao.descricao}<br />
            Data Cometimento: {dataHora}
          </small>
        </Col>

        <Col sm="4">
          <small>Maiores Informações: </small>
        </Col>
        <Col sm="2">
          <UncontrolledDropdown>
            <DropdownToggle color="dark" caret size="sm">
              <MdDriveEta size={30} />
              <p>Veículo</p>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem><small>Marca/Modelo: {veiculo.marcaModelo}</small></DropdownItem>
              <DropdownItem><small>Cor: {veiculo.cor}</small></DropdownItem>
              <DropdownItem><small>Placa: {veiculo.placa}</small></DropdownItem>
              <DropdownItem><small>Renavam: {veiculo.renavam}</small></DropdownItem>
              <DropdownItem><small>Emplacamento: {enderecoEmplacamento.municipio}</small></DropdownItem>
              <DropdownItem><small>Proprietário: {proprietario.nome}</small></DropdownItem>
              <DropdownItem><small>Tipo: {veiculo.tipo}</small></DropdownItem>
              <DropdownItem><small>Espécie: {veiculo.especie}</small></DropdownItem>
              <DropdownItem><small>Categoria: {veiculo.categoria}</small></DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Col>

        <Col sm="2">
          <UncontrolledDropdown>
            <DropdownToggle color="dark" caret size="sm">
              <MdPerson size={30} />
              <p>Condutor</p>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem><small>Condutor: {condutor.nome}</small></DropdownItem>
              <DropdownItem><small>CPF/CNPJ: {condutor.cpf}</small></DropdownItem>
              <DropdownItem><small>CNH: {condutor.cnh}</small></DropdownItem>
              <DropdownItem><small>Modelo CNH: {condutor.modeloCnh}</small></DropdownItem>
              <DropdownItem><small>UF Expedição: {condutor.ufExpedicaoCnh}</small></DropdownItem>
              <DropdownItem><small>Descrição do Documento: {condutor.tipoDocumentoCondutorNaoHabilitado}</small></DropdownItem>
              <DropdownItem><small>Número Documento Condutor Não Habilitado: {condutor.identificacaoCondutorNaoHabilitado}</small></DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Col>

        <Col sm="2">
          <UncontrolledDropdown>
            <DropdownToggle color="dark" caret size="sm">
              <MdContentPaste size={30} />
              <p>Infração</p>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem><small>Auto de Infração: {infracao.autoInfracao}</small></DropdownItem>
              <DropdownItem><small>Código da Infracao: {infracao.codigo}</small></DropdownItem>
              <DropdownItem><small>Local: {`${infracao.endereco.logradouro}, ${infracao.endereco.municipio} - ${infracao.endereco.uf}`}</small></DropdownItem>
              <DropdownItem><small>Data: {dataHora}</small></DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Col>
      </Row>
    </div>
  );
};

export default AutoInfracaoResumo;



// WEBPACK FOOTER //
// ./src/componentes/AutoInfracaoResumo.js